import script from "./washingMachineList.vue?vue&type=script&setup=true&lang=js"
export * from "./washingMachineList.vue?vue&type=script&setup=true&lang=js"

import "./washingMachineList.vue?vue&type=style&index=0&id=0143a583&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0143a583"]])

export default __exports__